import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel,
  CardHeader, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from "yup";
import { useAlert } from "react-alert";
import { LoadingComponent } from 'src/utils/newLoader';
import { trackPromise } from 'react-promise-tracker';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import authService from 'src/utils/permissionAuth';
import tokenService from 'src/utils/tokenDecoder';
import moment from 'moment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CreatePDF from './CreatePDF';
import ReactToPrint from 'react-to-print';
import xlsx from 'json-as-xlsx';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorApprove: {
    backgroundColor: "green",
  },
  stickyColumn: {
    position: 'sticky',
    left: 0,
    background: 'white',
    zIndex: 1,
    borderRight: '1px solid black',
  }
}));

const screenCode = 'ROUTEWISEPASTBALANCEPAYMENTREPORTNEW';

export default function RouteWisePastBalancePaymentReport(props) {
  const [title, setTitle] = useState(" Balance Payment Ledger Report");
  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [selectedDate, setSelectedDate] = useState(null);
  const [supplierWiseBalancePaymentEstimationDetails, setSupplierWiseBalancePaymentEstimationDetails] = useState([]);
  const [routeWiseBalancePaymentEstimationDetails, setRouteWiseBalancePaymentEstimationDetails] = useState([]);
  const [selectedRouteSupplierWiseBalanceDetails, setSelectedRouteSupplierWiseBalanceDetails] = useState([]);
  const [displaySupplierWiseTable, setDisplaySupplierWiseTable] = useState(false);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: '',
    factoryName: '',
    year: '',
    month: '',
    routeName: ''
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const [collectionTypeRate, setCollectionTypeRate] = useState({
    groupID: 0,
    factoryID: 0,
  });
  const classes = useStyles();
  const navigate = useNavigate();
  const alert = useAlert();
  const componentRef = useRef();

  useEffect(() => {
    getPermissions();
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    if (collectionTypeRate.groupID > 0) {
      trackPromise(getFactoriesForDropdown());
    }
  }, [collectionTypeRate.groupID]);

  useEffect(() => {
    if (collectionTypeRate.factoryID > 0 && collectionTypeRate.groupID > 0) {
      trackPromise(GetBalancePaymentYearMonthForDropDown());
    }
  }, [collectionTypeRate.factoryID]);

  useEffect(() => {
    setRouteWiseBalancePaymentEstimationDetails([]);
    setSelectedRouteSupplierWiseBalanceDetails([]);
    setSupplierWiseBalancePaymentEstimationDetails([]);
    setDisplaySupplierWiseTable(false);
  }, [collectionTypeRate.groupID, collectionTypeRate.factoryID, selectedDate]);

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWROUTEWISEPASTBALANCEPAYMENTREPORTNEW');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setCollectionTypeRate({
      ...collectionTypeRate,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken()),
    });
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroups(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getAllFactoriesByGroupID(collectionTypeRate.groupID);
    setFactories(factories);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
      }
    }
    return items
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value

    let newCollectionTypeRate = {
      ...collectionTypeRate,
      [e.target.name]: value
    };

    if (e.target.name === 'groupID') {
      newCollectionTypeRate.factoryID = 0;
    }

    setCollectionTypeRate(newCollectionTypeRate);
    setRouteWiseBalancePaymentEstimationDetails([]);
    setSelectedRouteSupplierWiseBalanceDetails([]);
    setSupplierWiseBalancePaymentEstimationDetails([]);
    setDisplaySupplierWiseTable(false);
  }

  function handleDateChange(date) {
    if (selectedDate != null) {
      var prevMonth = selectedDate.getUTCMonth() + 1;
      var prevyear = selectedDate.getUTCFullYear();
      var month = date.getUTCMonth() + 1;
      var year = date.getUTCFullYear();

      if ((prevyear == year && prevMonth != month) || (prevyear != year)) {
        setSelectedDate(date);
        setRouteWiseBalancePaymentEstimationDetails([]);
        setSelectedRouteSupplierWiseBalanceDetails([]);
        setSupplierWiseBalancePaymentEstimationDetails([]);
        setDisplaySupplierWiseTable(false);
      }
    } else {
      setSelectedDate(date);
    }
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  function renderRouteBalanceEstimationDetails(data) {
    const columns = [
      { id: "routeName", label: "Route" },
      { id: "totalNetWeight", label: "Crop Weight (KG)" },
      { id: "gross", label: "Gross" },
      { id: "totalAddition", label: "Addition Pay" },
      { id: "coinBF", label: "Coins" },
      { id: "transport", label: "Transport" },
      { id: "debtsBF", label: "B/F Debts" },
      { id: "fertilizerBF", label: "B/F Fertilizer" },
      { id: "advancePayment", label: "Advance" },
      { id: "teaDeduction", label: "Tea" },
      { id: "fertilizerDeductions", label: "Fertilizer" },
      { id: "festivalAdvance", label: "Festival Advance" },
      { id: "chemicalDeductions", label: "Chemical" },
      { id: "mealDeduction", label: "Meal" },
      { id: "loanPayment", label: "Loan" },
      { id: "stamp", label: "Stamp" },
      { id: "otherDeductions", label: "Other" },
      { id: "bankCharge", label: "Bank Charge" },
      { id: "totalDeductions", label: "Total Deductions" },
      { id: "balance", label: "Balance" },
      { id: "debtsCF", label: "C/F Debts" },
      { id: "fertilizerCF", label: "C/F Fertilizer" },
      { id: "loanBalance", label: "Loan Balance" },
      { id: "cash", label: "Cash" },
      { id: "bank", label: "Bank" },
      { id: "coinCF", label: "C/F Coins" },
      { id: "action", label: "Action" }
    ];

    const totals = columns.reduce((acc, column) => {
      if (column.id !== "routeName" && column.id !== "action") {
        acc[column.id] = data.reduce((sum, row) => sum + (parseFloat(row[column.id]) || 0), 0);
      }
      return acc;
    }, {});

    return (
      <Box minWidth={1050} hidden={false}>
        <TableContainer component={Paper} style={{ maxHeight: '550px', overflowY: 'auto' }}>
          <Table size="small" aria-label="simple table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    className={column.sticky ? classes.stickyColumn : ""}
                    style={{ border: "1px solid black", fontWeight: "bold", fontSize: "16px" }}
                    align="center"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <TableRow key={index}>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      className={column.sticky ? classes.stickyColumn : ""}
                      style={{ border: "1px solid black" }}
                      align={typeof (row[column.id]) === "number" ? "right" : "left"}
                    >
                      {column.id === "action" ? (
                        <IconButton onClick={() => viewSupplierWiseBalanceDetails(row.routeID)}>
                          <VisibilityIcon />
                        </IconButton>
                      ) : column.id === "routeName" ? (
                        row[column.id] ?? ""
                      ) : (
                        Number(row[column.id]).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    className={column.sticky ? classes.stickyColumn : ""}
                    style={{ border: "1px solid black", fontWeight: "bold" }}
                    align={typeof (totals[column.id]) === "number" ? "right" : "left"}
                  >
                    {column.id === "routeName"
                      ? "Total"
                      : column.id === "action"
                        ? " "
                        : Number(totals[column.id]).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                ))}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }

  function renderSupplierBalanceEstimationDetails(data) {
    const collectionTypeMap = new Map();
    data.forEach(row => {
      (row.balanceRates || []).forEach(br => {
        const key = br.collectionTypeID !== 0 ? br.collectionTypeID : br.collectionTypeName;
        if (key !== undefined && !collectionTypeMap.has(key)) {
          collectionTypeMap.set(key, { id: key, name: br.collectionTypeName || '' });
        }
      });
      (row.cropDetails || []).forEach(cd => {
        const key = cd.collectionTypeID !== 0 ? cd.collectionTypeID : cd.collectionTypeName;
        if (key !== undefined && !collectionTypeMap.has(key)) {
          collectionTypeMap.set(key, { id: key, name: cd.collectionTypeName || '' });
        }
      });
    });
    const rateColumns = Array.from(collectionTypeMap.values());

    const fixedRightColumns = [
      { id: 'supplierCropNet', label: 'Total Crop Weight' },
      { id: 'gross', label: 'Total Gross' },
      { id: 'totalAddition', label: 'Addition Pay' },
      { id: 'coinBF', label: 'Coins' },
      { id: 'transport', label: 'Transport' },
      { id: 'debtsBF', label: 'B/F Debts' },
      { id: 'fertilizerBF', label: 'B/F Fertilizer' },
      { id: 'advancePayment', label: 'Advance' },
      { id: 'teaDeduction', label: 'Tea' },
      { id: 'fertilizerDeductions', label: 'Fertilizer' },
      { id: 'festivalAdvance', label: 'Festival Advance' },
      { id: 'chemicalDeductions', label: 'Chemical' },
      { id: 'mealDeduction', label: 'Meal' },
      { id: 'loanPayment', label: 'Loan' },
      { id: 'stamp', label: 'Stamp' },
      { id: 'otherDeductions', label: 'Other' },
      { id: 'bankCharge', label: 'Bank Charge' },
      { id: 'totalDeductions', label: 'Total Deductions' },
      { id: 'balance', label: 'Balance' },
      { id: 'debtsCF', label: 'C/F Debts' },
      { id: 'fertilizerCF', label: 'C/F Fertilizer' },
      { id: 'loanBalance', label: 'Loan Balance' },
      { id: 'cash', label: 'Cash' },
      { id: 'bank', label: 'Bank' },
      { id: 'coinCF', label: 'C/F Coins' },
    ];

    const totals = fixedRightColumns.reduce((acc, col) => {
      acc[col.id] = data.reduce((sum, row) => {
        let val = row[col.id] ?? 0;
        if (col.id === 'supplierCropNet') {
          val = (row.cropDetails || []).reduce((sc, c) => sc + (parseFloat(c.cropWeight) || 0), 0);
        } else if (col.id === 'gross') {
          val = (row.cropDetails || []).reduce((sc, c) => sc + (parseFloat(c.amount) || 0), 0);
        }
        return sum + (parseFloat(val) || 0);
      }, 0);
      return acc;
    }, {});

    const headerRowSpan = rateColumns.length > 0 ? 2 : 1;
    const thStyle  = { border: '1px solid black', fontWeight: 'bold', fontSize: '16px' };
    const thStyle2 = { border: '1px solid black', fontWeight: 'bold', fontSize: '14px' };
    const tdStyle  = { border: '1px solid black' };
    const tdBold   = { border: '1px solid black', fontWeight: 'bold' };

    return (
      <Box minWidth={1050} hidden={false}>
        <Box display="flex" justifyContent="flex-start" p={2}>
          <Button color="secondary" variant="contained" size="medium"
            startIcon={<ArrowBackIcon />} onClick={() => handleGoBack()}>
          </Button>
        </Box>
        <TableContainer component={Paper} style={{ maxHeight: '550px', overflowY: 'auto' }}>
          <Table size="small" aria-label="simple table">
            <TableHead>
              
              <TableRow>
                <TableCell rowSpan={headerRowSpan} style={thStyle} align="center">Reg. No.</TableCell>
                <TableCell rowSpan={headerRowSpan} style={thStyle} align="center">Supplier Name</TableCell>
                <TableCell
                  colSpan={rateColumns.length > 0 ? rateColumns.length : 1}
                  style={thStyle}
                  align="center"
                >
                  Rate
                </TableCell>
                <TableCell
                  colSpan={rateColumns.length > 0 ? rateColumns.length : 1}
                  style={thStyle}
                  align="center"
                >
                  Crop Weight
                </TableCell>
                <TableCell
                  colSpan={rateColumns.length > 0 ? rateColumns.length : 1}
                  style={thStyle}
                  align="center"
                >
                  Gross
                </TableCell>
                {fixedRightColumns.map(col => (
                  <TableCell key={col.id} rowSpan={headerRowSpan} style={thStyle} align="center">
                    {col.label}
                  </TableCell>
                ))}
              </TableRow>
              {/* Row 2: leaf type names below "Rate", "Crop Weight", and "Gross" */}
              {rateColumns.length > 0 && (
                <TableRow>
                  {rateColumns.map(col => (
                    <TableCell key={`rate_${col.id}`} style={thStyle2} align="center">
                      {col.name}
                    </TableCell>
                  ))}
                  {rateColumns.map(col => (
                    <TableCell key={`crop_${col.id}`} style={thStyle2} align="center">
                      {col.name}
                    </TableCell>
                  ))}
                  {rateColumns.map(col => (
                    <TableCell key={`gross_${col.id}`} style={thStyle2} align="center">
                      {col.name}
                    </TableCell>
                  ))}
                </TableRow>
              )}
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <TableRow key={index}>
                  <TableCell style={tdStyle} align="left">{row.registrationNumber}</TableCell>
                  <TableCell style={tdStyle} align="left">{row.customerName}</TableCell>
                  {rateColumns.length > 0 ? (
                    rateColumns.map(col => {
                      const brItem = (row.balanceRates || []).find(item => {
                        const key = item.collectionTypeID !== 0 ? item.collectionTypeID : item.collectionTypeName;
                        return key == col.id;
                      });
                      const rateVal = brItem !== undefined ? (brItem.rate ?? 0) : 0;
                      return (
                        <TableCell key={`td_rate_${col.id}`} style={tdStyle} align="right">
                          {Number(rateVal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </TableCell>
                      );
                    })
                  ) : (
                    <TableCell style={tdStyle} align="right">
                      {Number(row.rate ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                  )}
                  {rateColumns.length > 0 ? (
                    rateColumns.map(col => {
                      const cdItems = (row.cropDetails || []).filter(item => {
                        const key = item.collectionTypeID !== 0 ? item.collectionTypeID : item.collectionTypeName;
                        return key == col.id;
                      });
                      const cropVal = cdItems.reduce((sum, item) => sum + (parseFloat(item.cropWeight) || 0), 0);
                      return (
                        <TableCell key={`td_crop_${col.id}`} style={tdStyle} align="right">
                          {Number(cropVal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </TableCell>
                      );
                    })
                  ) : (
                    <TableCell style={tdStyle} align="right">
                      {Number(row.supplierCropNet ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                  )}
                  {rateColumns.length > 0 ? (
                    rateColumns.map(col => {
                      const cdItems = (row.cropDetails || []).filter(item => {
                        const key = item.collectionTypeID !== 0 ? item.collectionTypeID : item.collectionTypeName;
                        return key == col.id;
                      });
                      const grossVal = cdItems.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
                      return (
                        <TableCell key={`td_gross_${col.id}`} style={tdStyle} align="right">
                          {Number(grossVal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </TableCell>
                      );
                    })
                  ) : (
                    <TableCell style={tdStyle} align="right">
                      {Number(row.gross ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                  )}
                  {fixedRightColumns.map(col => {
                    let cellVal = row[col.id] ?? 0;
                    if (col.id === 'supplierCropNet') {
                      cellVal = (row.cropDetails || []).reduce((sum, c) => sum + (parseFloat(c.cropWeight) || 0), 0);
                    } else if (col.id === 'gross') {
                      cellVal = (row.cropDetails || []).reduce((sum, c) => sum + (parseFloat(c.amount) || 0), 0);
                    }

                    return (
                      <TableCell key={col.id} style={tdStyle} align="right">
                        {Number(cellVal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
              {/* Totals row */}
              <TableRow>
                <TableCell style={tdBold}>Total</TableCell>
                <TableCell style={tdBold}> </TableCell>
                {rateColumns.length > 0 ? (
                  rateColumns.map(col => (
                    <TableCell key={`tot_rate_${col.id}`} style={tdBold}> </TableCell>
                  ))
                ) : (
                  <TableCell style={tdBold}> </TableCell>
                )}
                {rateColumns.length > 0 ? (
                  rateColumns.map(col => {
                    const colTotal = data.reduce((sum, r) => {
                      const cdItem = (r.cropDetails || []).find(item => {
                        const key = item.collectionTypeID !== 0 ? item.collectionTypeID : item.collectionTypeName;
                        return key == col.id;
                      });
                      return sum + parseFloat(cdItem !== undefined ? cdItem.cropWeight : 0);
                    }, 0);
                    return (
                      <TableCell key={`tot_crop_${col.id}`} style={tdBold} align="right">
                        {Number(colTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                    );
                  })
                ) : (
                  <TableCell style={tdBold} align="right">
                    {Number(data.reduce((sum, r) => sum + parseFloat(r.supplierCropNet || 0), 0)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                )}
                {rateColumns.length > 0 ? (
                  rateColumns.map(col => {
                    const colTotal = data.reduce((sum, r) => {
                      const cdItem = (r.cropDetails || []).find(item => {
                        const key = item.collectionTypeID !== 0 ? item.collectionTypeID : item.collectionTypeName;
                        return key == col.id;
                      });
                      return sum + parseFloat(cdItem !== undefined ? cdItem.amount : 0);
                    }, 0);
                    return (
                      <TableCell key={`tot_gross_${col.id}`} style={tdBold} align="right">
                        {Number(colTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                    );
                  })
                ) : (
                  <TableCell style={tdBold} align="right">
                    {Number(data.reduce((sum, r) => sum + parseFloat(r.gross || 0), 0)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                )}
                {fixedRightColumns.map(col => (
                  <TableCell key={col.id} style={tdBold} align="right">
                    {Number(totals[col.id]).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                ))}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }

  function getSelectedDropdownValuesForReport(searchForm, factorieslist) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: groups[searchForm.groupID],
      factoryName: factorieslist[searchForm.factoryID],
      year: searchForm.year,
      month: searchForm.month
    })
  }

  function viewSupplierWiseBalanceDetails(routeID) {
    const selectedRouteDetails = supplierWiseBalancePaymentEstimationDetails
      .filter(item => (item.routeID ?? item.RouteID) == routeID)
      .sort((a, b) => a.registrationNumber - b.registrationNumber);
    setSelectedRouteSupplierWiseBalanceDetails(selectedRouteDetails);
    setDisplaySupplierWiseTable(true);

    const matchedRoute = routeWiseBalancePaymentEstimationDetails.find(
      item => (item.routeID ?? item.RouteID) == routeID
    );
    setSelectedSearchValues({
      ...selectedSearchValues,
      routeName: matchedRoute?.routeName || matchedRoute?.RouteName || ''
    });
  }

  function handleGoBack() {
    setSelectedRouteSupplierWiseBalanceDetails([]);
    setDisplaySupplierWiseTable(false);
    setSelectedSearchValues({
      ...selectedSearchValues,
      routeName: ''
    })
  }

  async function getBalancePaymentEstimation() {
    if (!selectedDate) {
      alert.error("Please select a year and month");
      return;
    }

    let formdata = {
      groupID: parseInt(collectionTypeRate.groupID),
      factoryID: parseInt(collectionTypeRate.factoryID),
      applicableDate: moment(selectedDate).format(),
      applicableMonth: (selectedDate.getMonth() + 1).toString().padStart(2, '0'),
      applicableYear: selectedDate.getFullYear().toString(),
    };

    let response = await services.getBalancePaymentEstimation(formdata);
    if (response.statusCode === 'Success') {
      const supplierRaw = response.data?.supplierWiseBalancePaymentEstimation ?? [];
      const routeRaw = response.data?.routeWiseBalancePaymentEstimation ?? [];

      const supplierData = supplierRaw.map(s => ({
        ...s,
        routeName: s.routeName || s.RouteName || '',
        routeID: s.routeID ?? s.RouteID ?? 0,
        rate: s.rate ?? s.Rate ?? s.cropRate ?? s.CropRate ?? s.cropeRate ?? s.CropeRate ?? 0,
        supplierCropNet: s.supplierCropNet ?? s.SupplierCropNet ?? 0,
        gross: s.gross ?? s.Gross ?? 0,
        totalAddition: s.totalAddition ?? s.TotalAddition ?? 0,
        debtsBF: s.debtsBF ?? s.DebtsBF ?? 0,
        otherDeductions: s.otherDeductions ?? s.OtherDeductions ?? 0,
        totalDeductions: s.totalDeductions ?? s.TotalDeductions ?? 0,
        balanceRates: (s.balanceRates ?? s.BalanceRates ?? []).map(br => ({
          collectionTypeID: br.collectionTypeID ?? br.CollectionTypeID,
          collectionTypeName: br.collectionTypeName ?? br.CollectionTypeName ?? '',
          rate: br.rate ?? br.Rate ?? 0,
        })),
        cropDetails: (s.cropDetails ?? s.CropDetails ?? []).map(c => ({
          ...c,
          collectionTypeID: c.collectionTypeID ?? c.CollectionTypeID ?? 0,
          collectionTypeName: c.collectionTypeName ?? c.CollectionTypeName ?? '',
          cropWeight: c.cropWeight ?? c.CropWeight ?? c.netweight ?? c.Netweight ?? 0,
          amount: c.amount ?? c.Amount ?? 0
        })),
      }));

      setSupplierWiseBalancePaymentEstimationDetails(supplierData);
      const routeData = routeRaw.map(r => ({
        ...r,
        routeName: r.routeName || r.RouteName || '',
        routeID: r.routeID ?? r.RouteID ?? 0,
        supplierCropNet: r.supplierCropNet ?? r.SupplierCropNet ?? r.totalNetWeight ?? r.TotalNetWeight ?? 0,
        totalAddition: r.totalAddition ?? r.TotalAddition ?? 0,
        debtsBF: r.debtsBF ?? r.DebtsBF ?? 0,
        otherDeductions: r.otherDeductions ?? r.OtherDeductions ?? 0,
        totalDeductions: r.totalDeductions ?? r.TotalDeductions ?? 0,
      }));

      setRouteWiseBalancePaymentEstimationDetails(routeData);

      const factorieslist = await services.getAllFactoriesByGroupID(collectionTypeRate.groupID);
      let model = {
        groupID: parseInt(collectionTypeRate.groupID),
        factoryID: parseInt(collectionTypeRate.factoryID),
        year: selectedDate.getFullYear().toString(),
        month: new Date(2000, selectedDate.getMonth()).toLocaleString('en-US', { month: 'long' })
      };
      getSelectedDropdownValuesForReport(model, factorieslist);
    } else {
      alert.error(response.message);
    }
  }

  const getPageMargins = () => {
    return `@media print {
        @page {
            size: landscape !important;
            background-color: white !important;
        }
        body {
            transform-origin: top left;
            background-color: white !important;
        }
    }`;
  };

  async function createDataForExcel(array, dataType) {
    let res = [];

    if (!array) return res;

    let totals = {};

    const collectionTypeMap = new Map();
    array.forEach(row => {
      (row.balanceRates || []).forEach(br => {
        const key = br.collectionTypeID !== 0 ? br.collectionTypeID : br.collectionTypeName;
        if (key && !collectionTypeMap.has(key)) collectionTypeMap.set(key, br.collectionTypeName || '');
      });
      (row.cropDetails || []).forEach(cd => {
        const key = cd.collectionTypeID !== 0 ? cd.collectionTypeID : cd.collectionTypeName;
        if (key && !collectionTypeMap.has(key)) collectionTypeMap.set(key, cd.collectionTypeName || '');
      });
    });
    const typeNames = Array.from(collectionTypeMap.values());

    array.forEach(row => {
      let formattedRow = {};

      if (dataType === 'supplierWise') {
        formattedRow = {
          'Reg. No.': row.registrationNumber,
          'Supplier Name': row.customerName,
        };

        if (typeNames.length > 0) {
           typeNames.forEach(name => {
              formattedRow[name + ' Rate'] = 0;
              formattedRow[name + ' Crop Weight'] = 0;
              formattedRow[name + ' Gross'] = 0;
           });
           (row.balanceRates || []).forEach(br => {
              formattedRow[(br.collectionTypeName || '') + ' Rate'] = br.rate || 0;
           });
           (row.cropDetails || []).forEach(cd => {
              const name = (cd.collectionTypeName || '');
              formattedRow[name + ' Crop Weight'] = (formattedRow[name + ' Crop Weight'] || 0) + (parseFloat(cd.cropWeight) || 0);
              formattedRow[name + ' Gross'] = (formattedRow[name + ' Gross'] || 0) + (parseFloat(cd.amount) || 0);
           });
        } else {
           formattedRow['Rate'] = row.rate;
           formattedRow['Crop Weight (KG)'] = row.supplierCropNet;
           formattedRow['Gross'] = row.gross;
        }

        const rowTotalWeight = (row.cropDetails || []).reduce((sum, c) => sum + (parseFloat(c.cropWeight) || 0), 0);
        const rowTotalGross = (row.cropDetails || []).reduce((sum, c) => sum + (parseFloat(c.amount) || 0), 0);

        Object.assign(formattedRow, {
          'Total Crop Weight': rowTotalWeight,
          'Total Gross': rowTotalGross,
          'Addition Pay': row.totalAddition,
          'Coins': row.coinBF,
          'Transport': row.transport,
          'B/F Debts': row.debtsBF,
          'B/F Fertilizer': row.fertilizerBF,
          'Advance': row.advancePayment,
          'Tea': row.teaDeduction,
          'Fertilizer': row.fertilizerDeductions,
          'Festival Advance': row.festivalAdvance,
          'Chemical': row.chemicalDeductions,
          'Meal': row.mealDeduction,
          'Loan': row.loanPayment,
          'Stamp': row.stamp,
          'Other': row.otherDeductions,
          'Bank Charge': row.bankCharge,
          'Total Deductions': row.totalDeductions,
          'Balance': row.balance,
          'C/F Debts': row.debtsCF,
          'C/F Fertilizer': row.fertilizerCF,
          'Loan Balance': row.loanBalance,
          'Cash': row.cash,
          'Bank': row.bank,
          'C/F Coins': row.coinCF
        });

      } else {
        formattedRow = {
          'Route': row.routeName,
          'Crop Weight (KG)': row.totalNetWeight,
          'Gross': row.gross,
          'Addition Pay': row.totalAddition,
          'Coins': row.coinBF,
          'Transport': row.transport,
          'B/F Debts': row.debtsBF,
          'B/F Fertilizer': row.fertilizerBF,
          'Advance': row.advancePayment,
          'Tea': row.teaDeduction,
          'Fertilizer': row.fertilizerDeductions,
          'Festival Advance': row.festivalAdvance,
          'Chemical': row.chemicalDeductions,
          'Meal': row.mealDeduction,
          'Loan': row.loanPayment,
          'Stamp': row.stamp,
          'Other': row.otherDeductions,
          'Bank Charge': row.bankCharge,
          'Total Deductions': row.totalDeductions,
          'Balance': row.balance,
          'C/F Debts': row.debtsCF,
          'C/F Fertilizer': row.fertilizerCF,
          'Loan Balance': row.loanBalance,
          'Cash': row.cash,
          'Bank': row.bank,
          'C/F Coins': row.coinCF
        };
      }

      Object.keys(formattedRow).forEach(key => {
        if (typeof formattedRow[key] === 'number') {
          totals[key] = (totals[key] || 0) + formattedRow[key];
        }
      });

      res.push(formattedRow);
    });

    var totalRow = { 'Reg. No.': 'Total', 'Supplier Name': '', 'Route': 'Total' };
    Object.keys(totals).forEach(key => {
      if (key !== 'Reg. No.' && key !== 'Supplier Name') {
        totalRow[key] = totals[key];
      }

      if (key.match(/Rate$/)) {
        totalRow[key] = '';
      }
    });

    res.push(totalRow);

    var vr1 = {
      [dataType === 'supplierWise' ? 'Reg. No.' : 'Route']: 'Group :' + selectedSearchValues.groupName,
      [dataType === 'supplierWise' ? 'Supplier Name' : 'Crop Weight (KG)']: 'Factory :' + selectedSearchValues.factoryName,
    };

    res.push(vr1);

    var vr2 = {
      [dataType === 'supplierWise' ? 'Reg. No.' : 'Route']: selectedSearchValues.routeName.length === 0 ? 'Route : ' + 'All Routes' : 'Route : ' + selectedSearchValues.routeName,
      [dataType === 'supplierWise' ? 'Supplier Name' : 'Crop Weight (KG)']: 'Year And Month : ' + selectedSearchValues.year + " - " + selectedSearchValues.month,
    }

    res.push(vr2);

    return res;
  }

  async function createFile() {
    const dataType = displaySupplierWiseTable ? "supplierWise" : "routeWise";

    const file = await createDataForExcel(dataType === 'supplierWise' ? selectedRouteSupplierWiseBalanceDetails : routeWiseBalancePaymentEstimationDetails, dataType);

    if (!file.length) return;

    const sheetName = dataType ===
      'supplierWise' ? "Balance Payment Ledger Report" : "Route Wise Balance Payment Summary Report";

    const fileName = dataType === 'supplierWise'
      ? (sheetName + ' ' + selectedSearchValues.month + ' - ' + selectedSearchValues.year + ' ' + selectedSearchValues.factoryName + ' ' + selectedSearchValues.routeName)
      : (sheetName + ' ' + selectedSearchValues.month + ' - ' + selectedSearchValues.year + ' ' + selectedSearchValues.factoryName);

    let keys = Object.keys(file[0]);
    let tempCsvHeaders = keys.map(sitem => ({ label: sitem, value: sitem }));

    let dataA = [
      {
        sheet: 'Balance Payment Ledger Report',
        columns: tempCsvHeaders,
        content: file
      }
    ];

    xlsx(dataA, { sheetName, fileName, writeOptions: {} });
  }

  async function GetBalancePaymentYearMonthForDropDown() {
    var response = await services.GetBalancePaymentYearMonth(collectionTypeRate.groupID, collectionTypeRate.factoryID);
    const applicableYear = parseInt(response.applicableYear);
    const applicableMonth = parseInt(response.applicableMonth) - 1;
    setSelectedDate(new Date(applicableYear, applicableMonth));
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: collectionTypeRate.groupID,
              factoryID: collectionTypeRate.factoryID,
              selectedDate: selectedDate
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group required').min("1", 'Group required'),
                factoryID: Yup.number().required('Factory required').min("1", 'Factory required'),
                selectedDate: Yup.date().required('Select applicable month').nullable(),
              })
            }
            onSubmit={() => trackPromise(getBalancePaymentEstimation())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={values.groupID}
                              variant="outlined"
                              id="groupID"
                              InputProps={{
                                readOnly: !permissionList.isGroupFilterEnabled
                              }}
                              size='small'
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={values.factoryID}
                              variant="outlined"
                              id="factoryID"
                              InputProps={{
                                readOnly: !permissionList.isFactoryFilterEnabled
                              }}
                              size='small'
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                error={Boolean(touched.selectedDate && errors.selectedDate)}
                                fullWidth
                                helperText={touched.selectedDate && errors.selectedDate}
                                autoOk
                                variant="inline"
                                openTo="month"
                                views={["year", "month"]}
                                label="Year and Month *"
                                value={values.selectedDate}
                                onChange={(date) => handleDateChange(date)}
                                size='small'
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>

                        </Grid>

                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                          >
                            View Balance Payment
                          </Button>
                        </Box>

                        {routeWiseBalancePaymentEstimationDetails.length > 0 && !displaySupplierWiseTable ?
                          renderRouteBalanceEstimationDetails(routeWiseBalancePaymentEstimationDetails) :
                          displaySupplierWiseTable ?
                            renderSupplierBalanceEstimationDetails(selectedRouteSupplierWiseBalanceDetails) : null
                        }
                      </CardContent>
                      {routeWiseBalancePaymentEstimationDetails.length > 0 || selectedRouteSupplierWiseBalanceDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="button"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorApprove}
                            onClick={() => createFile()}
                            size="small"
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            documentTitle=" "
                            trigger={() => (
                              <Button
                                color="primary"
                                id="btnRecord"
                                type="button"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorCancel}
                                size="small"
                              >
                                PDF
                              </Button>
                            )}
                            pageStyle={getPageMargins()}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                            <CreatePDF
                              ref={componentRef}
                              selectedSearchValues={selectedSearchValues}
                              supplierWiseData={selectedRouteSupplierWiseBalanceDetails}
                              routeWiseData={routeWiseBalancePaymentEstimationDetails}
                              dataType={displaySupplierWiseTable ? "supplierWise" : "routeWise"}
                            />
                          </div>
                        </Box> : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
};
